'use client';
import { createContext } from 'react';

import { type UseBreakpoints, type BREAKPOINTS } from './use-breakpoints';

const breakpointsCtx = createContext({} as UseBreakpoints<typeof BREAKPOINTS>);

export { breakpointsCtx };
